// import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
// import { tap } from 'rxjs';

// import { ApiService } from './api.service';

// interface AuthUser {
//   id?: number;
//   name?: string;
//   email?: string;
//     platformRole?: 'USER' | 'SUPER_ADMIN';
//   role?: string;
// }

// interface LoginResponse {
//   token: string;
//   user: AuthUser;
// }

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthService {
//   private readonly tokenKey = 'cardapio_token';
//   private readonly userKey = 'cardapio_user';
//   private readonly restaurantKey = 'cardapio_restaurant';

//   constructor(
//     private api: ApiService,
//     private router: Router
//   ) {}

//   login(email: string, password: string) {
//     return this.api
//       .post<LoginResponse>('/auth/login', {
//         email: email.trim(),
//         password
//       })
//       .pipe(
//         tap(response => {
//           localStorage.setItem(
//             this.tokenKey,
//             response.token
//           );

//           localStorage.setItem(
//             this.userKey,
//             JSON.stringify(response.user)
//           );
//         })
//       );
//   }

//   logout(): void {
//     localStorage.removeItem(this.tokenKey);
//     localStorage.removeItem(this.userKey);
//     localStorage.removeItem(this.restaurantKey);

//     this.router.navigate(['/login']);
//   }

//   getToken(): string | null {
//     return localStorage.getItem(this.tokenKey);
//   }

//   isLoggedIn(): boolean {
//     return Boolean(this.getToken());
//   }

//   getUser(): AuthUser | null {
//     const storedUser =
//       localStorage.getItem(this.userKey);

//     if (!storedUser) {
//       return null;
//     }

//     try {
//       return JSON.parse(storedUser) as AuthUser;
//     } catch {
//       localStorage.removeItem(this.userKey);
//       return null;
//     }
//   }

//   setUser(user: AuthUser): void {
//     localStorage.setItem(
//       this.userKey,
//       JSON.stringify(user)
//     );
//   }

//   setRestaurant(restaurant: unknown): void {
//     localStorage.setItem(
//       this.restaurantKey,
//       JSON.stringify(restaurant)
//     );
//   }

//   getRestaurant<T = unknown>(): T | null {
//     const storedRestaurant =
//       localStorage.getItem(this.restaurantKey);

//     if (!storedRestaurant) {
//       return null;
//     }

//     try {
//       return JSON.parse(storedRestaurant) as T;
//     } catch {
//       localStorage.removeItem(this.restaurantKey);
//       return null;
//     }
//   }
// }


import {
  Injectable
} from '@angular/core';

import {
  Router
} from '@angular/router';

import {
  tap
} from 'rxjs';

import {
  ApiService
} from './api.service';


export interface AuthUser {
  id?: number;
  name?: string;
  email?: string;

  platformRole?:
    | 'USER'
    | 'SUPER_ADMIN';

  role?: string;
}


interface LoginResponse {
  token: string;
  user: AuthUser;
}


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly tokenKey =
    'cardapio_token';

  private readonly userKey =
    'cardapio_user';

  private readonly restaurantKey =
    'cardapio_restaurant';


  constructor(
    private api: ApiService,
    private router: Router
  ) {}


  login(
    email: string,
    password: string
  ) {

    return this.api
      .post<LoginResponse>(
        '/auth/login',
        {
          email:
            email.trim(),

          password
        }
      )
      .pipe(

        tap(response => {

          localStorage.setItem(
            this.tokenKey,
            response.token
          );

          localStorage.setItem(
            this.userKey,
            JSON.stringify(
              response.user
            )
          );

        })

      );
  }


  logout(): void {

    localStorage.removeItem(
      this.tokenKey
    );

    localStorage.removeItem(
      this.userKey
    );

    localStorage.removeItem(
      this.restaurantKey
    );

    this.router.navigate([
      '/login'
    ]);
  }


  getToken():
    string | null {

    return localStorage.getItem(
      this.tokenKey
    );
  }


  isLoggedIn():
    boolean {

    return Boolean(
      this.getToken()
    );
  }


  getUser():
    AuthUser | null {

    const storedUser =
      localStorage.getItem(
        this.userKey
      );

    if (!storedUser) {
      return null;
    }

    try {

      return JSON.parse(
        storedUser
      ) as AuthUser;

    } catch {

      localStorage.removeItem(
        this.userKey
      );

      return null;
    }
  }


  setUser(
    user: AuthUser
  ): void {

    localStorage.setItem(
      this.userKey,
      JSON.stringify(user)
    );
  }


  /*
   * Retorna true somente para
   * administrador global da plataforma.
   */
  isSuperAdmin():
    boolean {

    return (
      this.getUser()
        ?.platformRole ===
      'SUPER_ADMIN'
    );
  }


  setRestaurant(
    restaurant: unknown
  ): void {

    localStorage.setItem(
      this.restaurantKey,
      JSON.stringify(
        restaurant
      )
    );
  }


  getRestaurant<
    T = unknown
  >(): T | null {

    const storedRestaurant =
      localStorage.getItem(
        this.restaurantKey
      );

    if (!storedRestaurant) {
      return null;
    }

    try {

      return JSON.parse(
        storedRestaurant
      ) as T;

    } catch {

      localStorage.removeItem(
        this.restaurantKey
      );

      return null;
    }
  }
}